module.exports = __webpack_public_path__ + "img/filter.97ed6f99.svg";